import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../../../router/all_routes";
import DualListBox from "../../../duallistBox";
import Cookies from "js-cookie";
import { useUserPermissions } from "../../../UserPermissionsContext";
import CommonSelect, { Option } from "../../../../core/common/commonSelect";

type Permission = { id: number; name: string };

type Admin = {
  permissions: Array<number>;
  category_name: string | null;
  category_id: number;
};

type Disposition = {
  student_disposition_id: number;
  disposition_name: string;
};

type TicketType = {
  ticket_type_id: number;
  ticket_type: string;
};

interface ErrorMessages {
  category_name?: string[];
}

const WizClubAddCategory = () => {
  const routes = all_routes;
  const navigate = useNavigate();
  const [chosenPermissions, setChosenPermissions] = useState<Permission[]>([]);
  const [permissions, setPermissions] = useState<Permission[]>([]);
  const jwtToken = Cookies.get("authToken");
  const [dispositions, setDispositions] = useState<Disposition[]>([]);
  const [errorMessage, setErrorMessage] = useState<ErrorMessages>({});
  const { userPermissions, webApi } = useUserPermissions();
  const [isLoading, setIsLoading] = useState(false);
  const [selectedDisposition, setSelectedDisposition] =
    useState<Disposition | null>(null);
  const [typeOfTicket, setTypeOfTicket] = useState<TicketType[]>([]);
  const [selectedTypeOfTicket, setSelectedTypeOfTicket] =
    useState<TicketType | null>(null);

  const checkPermission = (action: any, subject: any) => {
    return userPermissions.some(
      (ability) => ability.action === action && ability.subject === subject
    );
  };

  const handlePermissionsChange = (selected: Permission[]) => {
    setChosenPermissions(selected);
    setNewAdmin({
      ...newAdmin,
      permissions: selected.map((permission) => permission.id),
    });
  };

  const [newAdmin, setNewAdmin] = useState<Admin>({
    category_name: null,
    category_id: 0,
    permissions: [],
  });

  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  // const fetchData = async () => {
  //   setIsLoading(true);
  //   try {
  //     const [dispositionsData, typeOfTicketData] = await Promise.all([
  //       fetchDispositions(),
  //       fetchTypeOfTicket(),
  //     ]);
  //     setDispositions(dispositionsData);
  //     setTypeOfTicket(typeOfTicketData);
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  useEffect(() => {
    if (!checkPermission("add_wizklubcategory", "wizklubcategory")) {
      navigate(routes.crmLandingPage);
    } else {
    }
  }, [userPermissions]);

  const updateData = async () => {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify(newAdmin),
    };
    const url = `${webApi}/wizklub/wizklub_categories/`;
    const response = await fetch(url, requestOptions);
     const errorData = await response.json();
     
    if (!response.ok) {
       if (errorData.code === "token_not_valid") {
        navigate("/academic/sri-chaitanya/crm/landing-page");
      }
      setErrorMessage(errorData);
      throw new Error("Network response was not ok");
    }
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      await updateData();
      navigate(routes.wizklubCategories);
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setNewAdmin({ ...newAdmin, [name]: value || null });
  };

  useEffect(() => {
    const forms = document.querySelectorAll(
      ".needs-validation"
    ) as NodeListOf<HTMLFormElement>;
    Array.from(forms).forEach((form) => {
      form.addEventListener(
        "submit",
        (event) => {
          if (!form.checkValidity()) {
            event.preventDefault();
            event.stopPropagation();
          }
          form.classList.add("was-validated");
        },
        false
      );
    });
  }, []);

  return (
    <div>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <h3 className="page-title">Wizklub Add Category</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to={routes.SummerCampCategories}>Categories</Link>
                  </li>
                  <li className="breadcrumb-item active">Add Category</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="row justify-content-center">
            <div className="col-sm-12 d-flex justify-content-center">
              <div
                className="card"
                style={{
                  width: "70%",
                  boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
                  borderRadius: "10px",
                }}
              >
                <div className="card-body">
                  <form onSubmit={handleSubmit} className="d-flex flex-column">
                    <div className="modal-body light-violet-bg d-flex">
                      {/* <div
                        className="mb-3 me-3"
                        style={{ width: "35%"}}
                      >
                        <label className="form-label">Disposition</label>
                        <CommonSelect
                          className="select"
                          options={dispositionOptions}
                          onChange={handleDispositionChange}
                        />
                      </div> */}
                      {/* <div
                        className="mb-3"
                        style={{ flex: "1 1 50%", maxWidth: "300px" }}
                      >
                        <label className="form-label">Ticket Type</label>
                        <CommonSelect
                          className="select"
                          options={ticketTypeOptions}
                          onChange={handleTicketTypeChange}
                        />
                      </div> */}
                    </div>
                    <div className="form-group mb-3" style={{ width: "35%" }}>
                      <label className="form-label">Category Name</label>
                      <input
                        type="text"
                        className={`form-control ${
                          errorMessage.category_name ? "is-invalid" : ""
                        }`}
                        name="category_name"
                        placeholder="Category Name"
                        onChange={handleInputChange}
                        value={newAdmin.category_name || ""}
                        required
                      />
                      {errorMessage.category_name && (
                        <div className="invalid-feedback">
                          {errorMessage.category_name[0]}
                        </div>
                      )}
                    </div>
                    <div className="modal-footer">
                      <Link
                        className="btn btn-primary"
                        type="submit"
                        to={routes.wizklubCategories}
                        style={{
                          backgroundColor: "lightcoral",
                          color: "white",
                          marginRight: "5px",
                        }}
                      >
                        Cancel
                      </Link>
                      <button
                        className="btn btn-primary"
                        type="submit"
                        disabled={isLoading}
                      >
                        {isLoading ? (
                          <i className="spinner-border spinner-border-sm"></i>
                        ) : (
                          <>Save</>
                        )}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WizClubAddCategory;
